import { Component } from 'react';

class DailyProgressCheckbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
    };
  }

  onClick() {
    const { handleClick, position_id } = this.props;
    const { checked } = this.state;

    const newChecked = !checked;

    this.setState({ checked: newChecked });

    handleClick(position_id, newChecked);
  }

  render() {
    const { position_id, position_name } = this.props;
    return (
      <div className="daily-progress-checkbox-container">
        <label>
          {position_name}
          <input
            className="daily-progress-checkbox"
            type="checkbox"
            value={position_id}
            onChange={this.onClick.bind(this)}
          ></input>
        </label>
      </div>
    );
  }
}

export default DailyProgressCheckbox;
